var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { CLOSE_BLUE_SVG } from "../../assets";
import Box from "../Box";
import TimeAgo from "react-timeago";
import { withRouter } from "react-router";
var NewsDetail = /** @class */ (function (_super) {
    __extends(NewsDetail, _super);
    function NewsDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NewsDetail.convertContent = function (item) {
        return item.original_rendered;
    };
    NewsDetail.prototype.generateYoutubeUrl = function (url) {
        if (url.includes('watch?v')) {
            var id = url.substr(url.indexOf('watch?v=') + 'watch?v='.length);
            return "//www.youtube.com/embed/" + id + "?enablejsapi=1&origin=" + location.hostname;
        }
        return url;
    };
    NewsDetail.prototype.render = function () {
        var _this = this;
        return React.createElement(Box, { className: "news-detail" },
            React.createElement("div", { className: 'news-info' },
                React.createElement("div", { className: 'title', onClick: function () {
                        _this.props.history.push(_this.props.location.pathname.split('/').reverse().slice(1).reverse().join('/'));
                    } }, this.props.item.provider.title),
                React.createElement("div", { className: 'time' },
                    React.createElement(TimeAgo, { date: this.props.item.posted_date })),
                React.createElement("div", { className: 'news-close', onClick: function () {
                        _this.props.history.goBack();
                    } },
                    React.createElement("img", { src: CLOSE_BLUE_SVG }))),
            React.createElement("div", { className: 'news-title' }, this.props.item.title),
            React.createElement("div", { className: 'news-seperator' }),
            this.props.item.video_url &&
                React.createElement("div", { className: 'news-youtube-container-max-height' },
                    React.createElement("div", { className: 'news-youtube-container' },
                        React.createElement("iframe", { className: 'news-youtube', width: "853", height: "480", src: this.generateYoutubeUrl(this.props.item.video_url), frameBorder: 0, allowFullScreen: true }))),
            React.createElement("div", { className: 'news-content', dangerouslySetInnerHTML: { __html: NewsDetail.convertContent(this.props.item) } }));
    };
    return NewsDetail;
}(React.PureComponent));
export default withRouter(NewsDetail);
//# sourceMappingURL=NewsDetail.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/views/NewsDetail.js
// module id = 1297
// module chunks = 0